import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ModuleService } from '../../Services/module.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { MatNavList, MatListItem } from '@angular/material/list';
import { AsyncPipe } from '@angular/common';
import { TranslationPipe } from '../../../../../Services/translation.pipe';

@Component({
    selector: 'aw-steps',
    templateUrl: './steps.component.html',
    styleUrls: ['./steps.component.less'],
    imports: [MatNavList, MatListItem, RouterLinkActive, RouterLink, RouterOutlet, AsyncPipe, TranslationPipe]
})
export class StepsComponent implements OnInit, OnDestroy {
  public steps: any[] = [];
  private moduleSubscription: Subscription;

  public constructor(
    public moduleService: ModuleService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public ngZone: NgZone) { }

  public ngOnInit(): void {
    this.steps = [];
    this.moduleSubscription = this.moduleService.module().subscribe((result: any) => {
      if (result != null) {
        this.steps = result.Steps;
      } else {
        this.steps = null;
      }
    });
  }

  public ngOnDestroy(): void {
    if (this.moduleSubscription) {
      this.moduleSubscription.unsubscribe();
    }
    this.steps = [];
  }

  public stepsTrackBy(index, item): any {
    return item.StepId;
  }
}
